// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_accordion_table__fF0oI {
    width: 100%;
}

.styles_accordion_table__fF0oI th {
    background-color: #F5F5F5;
    border-radius: 6px;
    color: #18316e;
    padding: 0.5rem 1rem;
    /* margin: 0 5rem; */
    position: relative;
    box-sizing: border-box;
    font-size: 1.1rem;
}

.styles_accordion_table__fF0oI th,
.styles_accordion_table__fF0oI td {
    border-bottom: 1px solid #ddd;
    padding: 8px;
    text-align: center;
    font-size: 1.1rem;
}

.styles_button_action_container__hqV-A {
    display: flex;
    justify-content: center;
}


.styles_button_action__eSH6L {
    align-items: center;
    background-color: #18316e;
    border: none;
    border-radius: 10px;
    color: white;
    cursor: pointer;
    display: flex;
    padding: 0.3rem 1.5rem;
}

.styles_accordion_details__NFE95 {
    /* background-color: #f1f1f1;   */
    box-shadow: 3px 3px 5px #f1f1f1;
    border-radius: 6px;
}

.styles_buttons__NFZpp {
    display: flex;
    justify-content: space-around;
    gap: 10px;
}

.styles_btn__otK-C {
    align-items: center;
    background-color: white;
    border: none;
    border-radius: 4px;
    color: #18316e;
    cursor: pointer;
    display: flex;
    font-size: 1rem;
    justify-content: center;
    padding: 10px 20px;
    width: 100%;
}

.styles_btn__otK-C span {
    margin-right: .5rem;
}

.styles_btn__otK-C:hover {
    background-color: #F5F5F5;
}

.styles_aviso_vazio__-GowE {
    color: #18316e;
    font-size: 1.2rem;
}

.styles_fila__ZQsz2 {
    background-color: orange;
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
}
.styles_processando__Nz6Ae {
    background-color: #18316e;
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
    animation: styles_pulse__R7eRG 1s infinite;
}
.styles_sucesso__ynFvk {
    background-color: green;
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
}
.styles_erro__vwxmV {
    background-color: red;
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
}

.styles_status_container__d1VND {
    align-items: center;
    display: flex;
    justify-content: center;
}

@keyframes styles_pulse__R7eRG {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.3);
        opacity: 0.7;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ImportarSpeds/TableRelatorio/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAEI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,0CAA4B;AAChC;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ","sourcesContent":[".accordion_table {\n    width: 100%;\n}\n\n.accordion_table th {\n    background-color: #F5F5F5;\n    border-radius: 6px;\n    color: #18316e;\n    padding: 0.5rem 1rem;\n    /* margin: 0 5rem; */\n    position: relative;\n    box-sizing: border-box;\n    font-size: 1.1rem;\n}\n\n.accordion_table th,\n.accordion_table td {\n    border-bottom: 1px solid #ddd;\n    padding: 8px;\n    text-align: center;\n    font-size: 1.1rem;\n}\n\n.button_action_container {\n    display: flex;\n    justify-content: center;\n}\n\n\n.button_action {\n    align-items: center;\n    background-color: #18316e;\n    border: none;\n    border-radius: 10px;\n    color: white;\n    cursor: pointer;\n    display: flex;\n    padding: 0.3rem 1.5rem;\n}\n\n.accordion_details {\n    /* background-color: #f1f1f1;   */\n    box-shadow: 3px 3px 5px #f1f1f1;\n    border-radius: 6px;\n}\n\n.buttons {\n    display: flex;\n    justify-content: space-around;\n    gap: 10px;\n}\n\n.btn {\n    align-items: center;\n    background-color: white;\n    border: none;\n    border-radius: 4px;\n    color: #18316e;\n    cursor: pointer;\n    display: flex;\n    font-size: 1rem;\n    justify-content: center;\n    padding: 10px 20px;\n    width: 100%;\n}\n\n.btn span {\n    margin-right: .5rem;\n}\n\n.btn:hover {\n    background-color: #F5F5F5;\n}\n\n.aviso_vazio {\n    color: #18316e;\n    font-size: 1.2rem;\n}\n\n.fila {\n    background-color: orange;\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n}\n.processando {\n    background-color: #18316e;\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n    animation: pulse 1s infinite;\n}\n.sucesso {\n    background-color: green;\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n}\n.erro {\n    background-color: red;\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n}\n\n.status_container {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n@keyframes pulse {\n    0%, 100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n    50% {\n        transform: scale(1.3);\n        opacity: 0.7;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion_table": `styles_accordion_table__fF0oI`,
	"button_action_container": `styles_button_action_container__hqV-A`,
	"button_action": `styles_button_action__eSH6L`,
	"accordion_details": `styles_accordion_details__NFE95`,
	"buttons": `styles_buttons__NFZpp`,
	"btn": `styles_btn__otK-C`,
	"aviso_vazio": `styles_aviso_vazio__-GowE`,
	"fila": `styles_fila__ZQsz2`,
	"processando": `styles_processando__Nz6Ae`,
	"pulse": `styles_pulse__R7eRG`,
	"sucesso": `styles_sucesso__ynFvk`,
	"erro": `styles_erro__vwxmV`,
	"status_container": `styles_status_container__d1VND`
};
export default ___CSS_LOADER_EXPORT___;
